// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__gvLH6","insightsList":"newBusinessInsightsMenu_insightsList__1L7jN","active":"newBusinessInsightsMenu_active__3I988"};